export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY!;
export const EMAIL_TEXT = 'info@savetorich.com';
